import React, { useEffect } from 'react';
import { userManager } from '../oidcConfig';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';
import { useTenant } from '../contexts/TenantContext';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { loginWithExternalToken } from '../services/authService';
import './OidcCallbackCommon.css'; // Import the CSS file for animations

const OidcCallbackCommon = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { fetchUserData, loadingUser, userData } = useUser();
  const { fetchTenantsFromApi, tenantData } = useTenant();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const user = await userManager.signinRedirectCallback().then(async user => {
          const idToken = user?.id_token;
          const accessToken = user?.access_token || null;

          if (!idToken) {
            const storageKey = `oidc.user:${userManager.settings.authority}:${userManager.settings.client_id}`;
            const stored = sessionStorage.getItem(storageKey);
            if (stored) {
              try {
                const parsed = JSON.parse(stored);
                idToken = parsed.id_token;
              } catch {}
            }
          }
          if (idToken) {
            await loginWithExternalToken(idToken, accessToken);
            // localStorage.setItem('access_token', idToken);
            window.dispatchEvent(new Event('tokenChanged'));
            await fetchUserData(); // Ensure user data is fetched after token is set

            // Fetch tenants and redirect to the first one
            const tenants = await fetchTenantsFromApi();
            console.log('OidcCallbackCommon Fetched tenants after OIDC callback:', tenants);

            if (tenants && tenants.length > 0) {
            //   const firstTenant = tenants[0];
            //   navigate(`/app/${firstTenant.subdomain_prefix}/dashboard`);
            navigate('/sas');
            } else {
              console.error('OidcCallbackCommon No tenants found. Redirecting to login.');
              navigate('/', { replace: true });
            }
          } else {
            console.error('OidcCallbackCommon No id_token found after OIDC callback. Redirecting to login.');
            navigate('/', { replace: true });
          }
        }).catch((error) => {
          if (error.message.includes('AADSTS54005')) {
            console.error('OidcCallbackCommon Authorization code already redeemed. Redirecting to login.');
            navigate('/login', { replace: true });
          } else {
            console.error('OidcCallbackCommon Error during OIDC callback processing.', error);
            navigate('/', { replace: true });
          }
        });
      } catch (error) {
        console.error('OidcCallbackCommon Error handling OIDC callback:', error);
        navigate('/', { replace: true });
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <div>
        <Box sx={{ py: 2,textAlign: 'center', mb: 2 }}>
            <Typography sx={{ variant: "h6", gutterBottom: true, pt: 8 }}>  </Typography>
            <img
                // src="/logo_banane_transparent.png"
                src="/animation_loading.gif"
                alt={t('login.logoAlt')}
                className="login-logo-image rotate-animation" // Added animation class
                style={{ height: '60px' }} // Adjust size as needed
            />
            <Typography sx={{ variant: "h6", gutterBottom: true, pt: 8 }}>
                {t('login.processing')}
            </Typography>
        </Box>
        
    </div>
  );
};

export default OidcCallbackCommon;